import { render, staticRenderFns } from "./lrEditTable.vue?vue&type=template&id=f5c6f5b6"
import script from "./lrEditTable.vue?vue&type=script&lang=js"
export * from "./lrEditTable.vue?vue&type=script&lang=js"
import style0 from "./lrEditTable.vue?vue&type=style&index=0&id=f5c6f5b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports